import * as THREE from "three"
import { useGLTF, useTexture } from '@react-three/drei'
import { Canvas, useFrame, useThree } from 'react-three-fiber'
import create from "zustand"

import * as Tone from "tone"
import React, { Suspense, useRef, useCallback, useEffect, useMemo, useState } from "react"
import lerp from "lerp"
import { TweenMax, Sine, gsap } from "gsap"
import inst from "./inst"

let hitCount = 0
let isMobile = window.innerWidth < 500
let xWidth = isMobile ? 20 : 80

gsap.defaults({
  ease: Sine.easeOut
})
const col = 18
let noteLen = '0.2'
let getInst = () => {
  hitCount++
  return (hitCount % 2 === 0) ? inst.synthL : inst.synthR
}
const [useStore] = create((set, get) => ({
  startTime: null,
  started: false,
  sequence: [],
  parts: [],
  mutation: {
    mouseDown: false,
    pageX: window.innerWidth / 2,
    pageY: window.innerHeight / 2,
    meter: 0,
    timeSpeed: 0,
    interval: '0',
    dir: 0,
    dirTarget: 0,
    locked: false,
    front: 1,
    accent: '8'
  },
  locked: false,
  set: (key, val) => set(() => {
    return { [key]: val };
  }),
}))

function Rings(props) {
  const rings = useMemo(() => new Array(7).fill().map((v, i) => new THREE.TorusGeometry(20 * (i + 1), 3, 16, 100)), []);
  const mat = useMemo(() => new THREE.MeshStandardMaterial('white'), []);
  const mutation = useStore(state => state.mutation)
  console.log(rings)
  return (
    <>
      {new Array(rings.length).fill().map((v, i) => {
        return <mesh
          key={i}
          geometry={rings[i]}
          material={mat}
        >
        </mesh>
      })
      }
    </>
  );
}

function Rig() {
  const { camera, mouse } = useThree()
  const vec = new THREE.Vector3()
  return useFrame(() => {
    camera.position.lerp(vec.set(-mouse.x * 6, -mouse.y * 6, camera.position.z), 0.)
    camera.lookAt(0, 0, 0)

  })
}

function Swarm({ count }) {
  const mutation = useStore(state => state.mutation)

  const mesh = useRef()
  const dummy = useMemo(() => new THREE.Object3D(), [])

  const particles = useMemo(() => {
    const temp = []
    for (let i = 0; i < count; i++) {
      const t = Math.random() * 100
      const factor = 20 + Math.random() * 100
      const speed = 0.01 + Math.random() / 200
      const xFactor = (-xWidth / 2) + Math.random() * xWidth
      const yFactor = -20 + Math.random() * 20
      const zFactor = -30 + Math.random() * 60
      temp.push({ t, factor, speed, xFactor, yFactor, zFactor, mx: 0, my: 0 })
    }
    return temp
  }, [count])

  const mult = 0.08;
  useFrame(state => {
    mutation.timeSpeed = lerp(mutation.timeSpeed, (mutation.mouseDown ? 0.03 : 0), (mutation.mouseDown ? 0.2 : 0.1))
    mutation.meter = lerp(mutation.meter, Math.abs(inst.meterL.getValue() + inst.meterR.getValue()) * (isMobile ? 200 : 400), 0.1)
    mutation.dir = lerp(mutation.dir, mutation.dirTarget, 0.002)
    particles.forEach((particle, i) => {
      let { t, factor, speed, xFactor, yFactor, zFactor } = particle
      t = particle.t += ((speed / 110) + mutation.timeSpeed * (i / count)) * mutation.dir
      const a = Math.cos(t) + Math.sin(t * 1) / 10
      const b = Math.sin(t) + Math.cos(t * 2) / 10
      const s = 0.4 + Math.max(0.25, Math.cos(t) * 1.3) * mutation.meter
      particle.mx += ((mutation.pageX/window.innerWidth * (window.innerWidth * mult)) - particle.mx) * 0.01
      particle.my += (mutation.pageY/window.innerHeight * (window.innerHeight * mult) - particle.my) * 0.02
      dummy.position.set(
        (particle.mx / 10) * a + xFactor + Math.cos((t / 10) * factor) + (Math.sin(t * 1) * factor) / 10,
        10 + (particle.my / 10) * mutation.front * b + yFactor + Math.sin((t / 10) * factor) + (Math.cos(t * 2) * factor) / 200,
        (-50 * (mutation.front)) + (particle.my / 10) * b + zFactor + Math.cos((t / 10) * factor) + (Math.sin(t * 3) * factor) / 10
      )
      dummy.scale.set(s, s, s)
      dummy.updateMatrix()
      mesh.current.setMatrixAt(i, dummy.matrix)
    })
    mesh.current.instanceMatrix.needsUpdate = true
  })

  return (
    <>
      <instancedMesh ref={mesh} args={[null, null, count]}>
        <sphereBufferGeometry attach="geometry" args={[0.1, 16, 16]} />
        <meshBasicMaterial attach="material" color="white"
        />
      </instancedMesh>
    </>
  )
}
export default function () {
  const mutation = useStore(state => state.mutation)
  const set = useStore(state => state.set)
  const locked = useStore(state => state.locked)
  const inverter1 = useRef()
  const inverter2 = useRef()
  const inverter3 = useRef()
  const inverted = useRef(false)

  useEffect(() => {
    setInterval(() => {
      if (!mutation.mouseDown || mutation.interval.indexOf('0') === -1) return
      play(2)
    }, 140)
    setInterval(() => {
      if (!mutation.mouseDown || mutation.interval.indexOf('1') === -1) return
      play(2.5)
    }, 160)
    setInterval(() => {
      if (!mutation.mouseDown || mutation.interval.indexOf('2') === -1) return
      play(3)
    }, 333.33)
    setInterval(() => {
      if (!mutation.mouseDown || mutation.interval.indexOf('3') === -1) return
      play(4)
    }, 666.66)
    setInterval(() => {
      if (!mutation.mouseDown || mutation.interval.indexOf('4') === -1) return
      play(2.5)
    }, 200)
    setInterval(() => {
      if (!mutation.mouseDown || mutation.interval.indexOf('5') === -1) return
      play(3.4)
    }, 700)

    setInterval(() => {
      randomize()
    }, 12000)
  }, [])

  const play = useCallback((vel) => {
    let s = getInst()
    let hit = 0
    let punch = 0
    mutation.meter = mutation.meter + vel
    for(let i = 0; i < mutation.accent.length; i ++) {
      if (hitCount%mutation.accent[i] === 0) {
        hit = 87 * mutation.accent[i];
        punch = 0.1
        break;
      }
    }
    s.triggerAttackRelease(20 + (isMobile ? (mutation.pageX*1.5):(mutation.pageY*0.4)) + hit, noteLen, '+0.01', vel + (Math.random() * 0.2) + punch);
  }, [])
  let ramps = ['linearRampTo','exponentialRampTo']
  const randomize = useCallback((vel) => {
    if (mutation.locked) return
    mutation.accent = ''
    mutation.interval = ''
    new Array(12).fill().forEach((v, i) => Math.random() > 0.8 ? mutation.accent += (i+1) : null)
    new Array(6).fill().forEach((v, i) => Math.random() > 0.8 ? mutation.interval += i : null)
    console.log(mutation.accent)
    if (mutation.interval.length === 0)
      mutation.interval = '0'
    mutation.dirTarget = (Math.random() * 3) - 1.5
    inverter1.current.style.width = '0vw'
    inverter1.current.style.height = '0vh'
    inverter2.current.style.width = '0vw'
    inverter2.current.style.height = '0vh'
    if (inverted.current) {
      TweenMax.to('.playback', 1.2, { scale: 0, ease: Sine.easeIn })
      TweenMax.to('.playback', 1.8, { delay: 1.8, scale: 1, ease: Sine.easeOut })
      TweenMax.to('.invert1', 1.2, { delay: 1.2, width: '200vw', height: '200vw', ease: Sine.easeIn })
      inverter3.current.style.width = '0vw'
      inverter3.current.style.height = '0vh'
      TweenMax.to(mutation, 1.2, { front: 0.4, ease: Sine.easeOut })
      TweenMax.to(mutation, 2, { delay: 1.2, front: 1, ease: Sine.easeOut })
    } else {
      TweenMax.to('.playback', 1.2, { scale: 0, ease: Sine.easeIn })
      TweenMax.to('.playback', 1.8, { delay: 1.8, scale: 1, ease: Sine.easeOut })
      TweenMax.to('.invert2', 1.2, { delay: 1.2, width: '200vw', height: '200vw', ease: Sine.easeIn })
      inverter3.current.style.width = '200vw'
      inverter3.current.style.height = '200vw'
      TweenMax.to(mutation, 1.2, { front: 0.4, ease: Sine.easeOut })
      TweenMax.to(mutation, 2, { delay: 1.2, front: 1, ease: Sine.easeOut })
    }
    inverted.current = !inverted.current


    let rampTime = 1
    
    inst.delayL.wet[ramps[Math.round(Math.random())]](Math.random() * 0.9, rampTime)
    inst.delayL.delayTime[ramps[Math.round(Math.random())]](Math.random() * 4, rampTime)
    inst.delayL.feedback[ramps[Math.round(Math.random())]](Math.random() * 0.6, rampTime)

    inst.delayR.wet[ramps[Math.round(Math.random())]](Math.random() * 0.9, rampTime)
    inst.delayR.delayTime[ramps[Math.round(Math.random())]](Math.random() * 4, rampTime)
    inst.delayR.feedback[ramps[Math.round(Math.random())]](Math.random() * 0.6, rampTime)
  }, [])

  const mouseUp = useCallback(() => {
    mutation.mouseDown = false
  }, [])

  const mouseDown = useCallback((e) => {
    play(2)
    mutation.mouseDown = true
  }, [])

  const mouseMove = useCallback((e) => {
    if (e.buttons === 0) {
      mutation.mouseDown = false
    }
    mutation.pageX = e.pageX
    mutation.pageY = window.innerHeight - e.pageY
  }, [])
  let aspect = window.innerWidth / window.innerHeight
  return (
    <>
      <Canvas camera={{ position: [0, 0, 10 - (aspect * 3)], fov: 60, far: 300 }}
        onPointerMove={mouseMove}
        onMouseMove={mouseMove}
        onMouseUp={mouseUp}

        onPointerDown={mouseDown}
        onPointerUp={mouseUp}

        gl={{ antialias: true }}
        //pixelRatio={0.4 * window.devicePixelRatio}
        onCreated={({ gl }) => {
          gl.toneMapping = THREE.ACESFilmicToneMapping
          gl.outputEncoding = THREE.sRGBEncoding
        }}
      >
        <ambientLight intensity={0.4} />
        <spotLight
          position={[10, 10, 10]}
          angle={0.2}
          penumbra={1}
          intensity={0.2}
        />
        <Suspense fallback={null}>
          <Rings />
          <Swarm count={1500} />
        </Suspense>
        <Rig />
        <directionalLight position={[-1, 4, -2]} intensity={2} color="red" />
        <pointLight position={[-1, -4, -0]} intensity={3} color="green" />
      </Canvas>
      <div ref={inverter1} className='invert1' />
      <div ref={inverter2} className='invert2' />
      <div ref={inverter3} className='invert3' />
      <div className={locked ? 'playback locked' : 'playback'} onPointerDown={() => {
        mutation.locked = !locked
        set('locked', !locked)
        play(2)
        if(!mutation.locked){
          randomize()
        }
      }}
        onMouseMove={mouseMove}
      ><div /></div>
    </>
  )
}

console.log('%c🌱🌱 @ramioso 2021-05-24 🌱🌱 ', 'color: orange');